(function ($) {
    function resizeFooterPadder() {
        var footerPadder = $('.footer-padder');
        var footerCont = $('footer.footer');

        footerPadder.css('height', footerCont.outerHeight() + 'px' );
    }

    $(document).ready(resizeFooterPadder);
    $(window).ready(resizeFooterPadder);
    $(window).resize(resizeFooterPadder);
})(jQuery);